export default __webpack_public_path__ + "static/consul-agent-architecture-c43b9bdc77878048a3df80dca16fa381.webp";